export default __webpack_public_path__ + "f69787c19491948fdff33151509820a4.svg";